export default __webpack_public_path__ + "static/media/return_icon.e9d72c01.svg";